import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiManualReviewData, type EnrollmentMultiManualReviewSubmitOutput } from '../../../../models'

export const getEnrollmentMultiManualReviewDataMock: EnrollmentMultiManualReviewData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/manual-review',
  enrollmentData: {
    applicationId: '305802305',
  },
}

export const submitEnrollmentMultiManualReviewDataMock: EnrollmentMultiManualReviewSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/next-page-here',
}

export const mockGetEnrollmentMultiManualReviewData = graphql.mutation('getEnrollmentMultiManualReviewData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiManualReviewDataMock } })
})

export const mockSubmitEnrollmentMultiManualReviewData = graphql.mutation(
  'submitEnrollmentMultiManualReviewData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiManualReviewDataMock } })
  },
)

export const mockEnrollmentMultiManualReview = [
  mockGetEnrollmentMultiManualReviewData,
  mockSubmitEnrollmentMultiManualReviewData,
]
